export const MODERATE = 'moderate';
